import React from 'react';
import { Link } from 'react-router-dom';
import pinterpolate from 'pinterpolate';
import type { InterpolationParams, LinkComponentFactory, TextComponentFactory } from 'interface/component';

const toTextComponent = (string: string): TextComponentFactory => {
  return string && (() => <>{string}</>);
};

const toLinkComponent = (
  label: string,
  url: string,
  params: InterpolationParams = {},
  blank?: boolean
): LinkComponentFactory => {
  return (
    label &&
    (() => (
      <a href={pinterpolate(url, params)} className="break-word" target={blank && '_blank'} rel="noopener noreferrer">
        {label}
      </a>
    ))
  );
};

const toRouteComponent = (
  label: string,
  url: string,
  params: InterpolationParams = {},
  target?: string
): LinkComponentFactory => {
  return (
    label &&
    (() => (
      <Link to={pinterpolate(url, params)} target={target}>
        {label}
      </Link>
    ))
  );
};

export { toTextComponent, toLinkComponent, toRouteComponent };
